<template>
  <div class="full_height_datatable" :style="heightStyle">
    <ag-grid-vue style="width: 100%; height: 100%"
                 class="ag-theme-balham"
                 :gridOptions="gridOptions"
                 :columnDefs="columnDefs"

                 :defaultColDef="defaultColDef"
                 :rowData="rowData"
                 :rowHeight="rowHeight"
                 :animateRows="true"
                 @first-data-rendered="onFirstDataRendered"

                 @row-clicked="onRowClicked"

                 :frameworkComponents="frameworkComponents"
                 :loadingOverlayComponent="loadingOverlayComponent"
                 :loadingOverlayComponentParams="loadingOverlayComponentParams"
                 :noRowsOverlayComponent="noRowsOverlayComponent"
                 :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import OverlayLoading from "./overlay_loading";
import OverlayNoRows from "./overlay_no_rows";

import {mapActions} from 'vuex'

export default {
  name: "timesheet_additional_payments_datatable",
  components: {
    AgGridVue,
    OverlayLoading,
    OverlayNoRows,
  },
  props: {
    heightStyle: '',
    rowData: null,
    loadingMessage: {type: String, default: 'Loading...'},
    noRowsMessage: {type: String, default: 'No Rows Found'},
    columns: null,
    type: {type: String, required: false},
    subType: {type: String, required: false},
    compliance: {type: String, required: false},
    recordType: {type: String, required: false},
    paginationSize: {type: Number, required: false, default: 25}
  },

  data() {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowHeight: null,

      frameworkComponents: null,
      loadingOverlayComponent: null,
      loadingOverlayComponentParams: null,
      noRowsOverlayComponent: null,
      noRowsOverlayComponentParams: null,
    }
  },
  beforeMount() {
    this.gridOptions = {
      suppressCellSelection: true,
      pagination: true,
      paginationPageSize: this.paginationSize,
      rowStyle: {
        'border-bottom': 'white 1px solid',
        'border-top': 'white 1px solid',
      },
      onColumnResized: this.onColumnResized,
    };

    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      filterParams: {newRowsAction: 'keep', buttons: ['reset'],},
      cellStyle: {"white-space": "normal"},
      unSortIcon: true,
      suppressMenu: true,
      autoHeight: true,
      suppressSizeToFit: false,
      flex: 1,
      wrapText: true,     // <-- HERE
    };
    this.frameworkComponents = {
      customLoadingCellRenderer: OverlayLoading,
      customNoRowsOverlay: OverlayNoRows,
    };
    this.loadingOverlayComponent = 'customLoadingCellRenderer';
    this.loadingOverlayComponentParams = {loadingMessage: this.loadingMessage};
    this.noRowsOverlayComponent = 'customNoRowsOverlay';
    this.noRowsOverlayComponentParams = {noRowsMessage: this.noRowsMessage};

    this.columnDefs = this.columns;
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    ...mapActions(['showRightInfo']),

    onRowClicked(params) {
      // if (params.data.id !== null) {
      //   this.$store.commit('CURRENT_RIGHT_INFO_TABLE_ROW', {
      //     node_id: params.node.id
      //   });
      //   this.showRightInfo({data: params.data, type: 'workers'});
      // }
      // console.log(params.data.worker_id)
    },

    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
      params.api.resetRowHeights();
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    }
  },
}
</script>
